// How much of the streak day is left, as a short human string: "6h 12m", "48m", "<1m".
//
// Returns null once the deadline has passed — the caller treats that as "the server's answer is
// now stale", not as "0m left": the streak has actually reset by then and only a refetch knows
// what it reset to.
//
// Deliberately coarse. The display never shows seconds, so the caller can tick every 30s instead
// of every second, and a countdown that ticks in whole minutes reads as information rather than
// as a clock running out on you.
export function formatRemaining(ms: number): string | null {
  if (ms <= 0) return null;

  const totalMinutes = Math.floor(ms / 60_000);
  if (totalMinutes < 1) return '<1m';

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
}

// Under an hour the countdown changes tone (see StreakCountdown) — pulled out so the threshold is
// named once rather than repeated as a magic number at the call site.
export const URGENT_THRESHOLD_MS = 60 * 60_000;
